import { isFunction } from "lodash";
import { CommunityLogo } from "./CommunityLogo";

const LOGO_TYPES = {
  LOGO: "logo",
  ICON: "icon",
};

export interface LogoLinkProps {
  as?: "button" | "div";
  communityName: string;
  logoType: "logo" | "icon";
  logoUrl?: string | null;
  onLogoClick?: () => void;
}

export const LogoLink = ({
  communityName,
  logoType,
  logoUrl,
  as = "button",
  onLogoClick,
}: LogoLinkProps) => {
  const Component = as;

  const buttonProps = {
    type: "button",
  };

  return (
    <Component
      className="w-full min-w-0"
      id="community-logo-wrapper"
      onClick={() => isFunction(onLogoClick) && onLogoClick()}
      {...(as === "button" && {
        buttonProps,
      })}
    >
      {logoType === LOGO_TYPES.LOGO && logoUrl ? (
        <CommunityLogo name={communityName} src={logoUrl} />
      ) : (
        <div className="text-c-header flex items-center gap-2">
          {logoUrl && (
            <div>
              <CommunityLogo name={communityName} src={logoUrl} />
            </div>
          )}
          <div className="w-full min-w-0">
            <h1
              data-testid="title-name"
              className="text-c-header truncate text-left text-xl font-semibold normal-case leading-7 tracking-normal"
            >
              {communityName}
            </h1>
          </div>
        </div>
      )}
    </Component>
  );
};
